"use client";

import { useQuery } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

import { handleMaintenanceRedirect } from "@/lib/scheduled-maintenance/helpers";

const FIVE_MINUTES_IN_MS = 1000 * 60 * 5;

export const ClientScheduledMaintenanceChecker = () => {
  const currentPathName = usePathname();
  const router = useRouter();
  const isAdminPage = currentPathName.startsWith("/admin");
  const isLoginPage = currentPathName.startsWith("/login");
  const isEmbedPage = currentPathName.startsWith("/embed");
  const isSharePage = currentPathName.startsWith("/share");
  const enabled = Boolean(
    !isAdminPage && !isLoginPage && !isEmbedPage && !isSharePage,
  );
  const { data: scheduledMaintenance, isLoading } = useQuery({
    queryKey: ["scheduled-maintenance"],
    queryFn: async () => {
      const response = await fetch(
        `${window.location.origin}/api/scheduled-maintenances`,
      );
      return response.json();
    },
    enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    // Refetch every 5 minutes
    refetchInterval: FIVE_MINUTES_IN_MS,
  });

  useEffect(() => {
    if (enabled && !isLoading) {
      const check = async () => {
        await handleMaintenanceRedirect({
          currentPathName,
          scheduledMaintenance,
          redirectFn: (path: string) => router.push(path),
        });
      };
      check();
    }
  }, [
    currentPathName,
    scheduledMaintenance,
    isLoading,
    isAdminPage,
    isSharePage,
    enabled,
    router,
  ]);

  return null;
};
